module.exports = __webpack_public_path__ + "img/bdColor.49347361.png";